import React, { createContext, useContext } from 'react';
const OnCloseLanguageContext = createContext(() => undefined);
const OnCloseMenuContext = createContext(() => undefined);
const OnCloseLanguageProvider = ({ children, onClose, }) => (React.createElement(OnCloseLanguageContext.Provider, { value: onClose }, children));
const OnCloseMenuProvider = ({ children, onClose }) => (React.createElement(OnCloseMenuContext.Provider, { value: onClose }, children));
const useLanguageOnClose = () => useContext(OnCloseLanguageContext);
const useMenuOnClose = () => useContext(OnCloseMenuContext);
export { OnCloseLanguageProvider, OnCloseMenuProvider, useLanguageOnClose, useMenuOnClose };
